import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
// import { getOurCulturePhotos} from "../actions";
import { getRecentJobListingApi } from '../../API/API'

function* getRecentJobListingSaga(params) {
  try {
    const response = yield call(() => getRecentJobListingApi(params)); // API Backend
    yield put({ type: types.GET_JOB_LISTING_RECENT_SUCESS, payload: response.data });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_JOB_LISTING_RECENT_FAILURE, error });
  }
}

export function* watchGetRecentJobListing() {
  yield takeEvery(types.GET_JOB_LISTING_RECENT_REQUESTED, getRecentJobListingSaga);
}